import {combineEpics} from 'redux-observable';
import inquiryVariantsListEpic from "./inquiryVariantListEpic";
import axaInsuranceEpic from "./axaInsuranceEpic";

export const rootEpic = combineEpics(
    inquiryVariantsListEpic,
    axaInsuranceEpic
);
